import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "rdr_cookie_consent_v1";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, date: new Date().toISOString() })
      );
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[80] px-4 pb-4 sm:px-6 sm:pb-6 animate-fade-up">
      <div className="max-w-3xl mx-auto bg-[#ffffff] border border-[#dcd4c5] rounded-sm shadow-2xl">
        <div className="p-6 sm:p-7 flex flex-col md:flex-row md:items-center gap-5">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Cookie size={18} className="text-gold" />
              <h3 className="text-[12px] tracking-[0.25em] uppercase text-[#17140f]">
                Cookies & Datenschutz
              </h3>
            </div>
            <p className="text-[#5b564a] text-sm leading-relaxed">
              Wir verwenden Cookies, um deinen Warenkorb zu speichern und die
              Nutzung unserer Seite zu verbessern. Mit „Alle akzeptieren" stimmst
              du der Verwendung zu. Mehr dazu in unserer{" "}
              <Link to="/datenschutz" className="text-gold hover-underline">
                Datenschutzerklärung
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0">
            <button
              onClick={() => decide("necessary")}
              className="border border-[#c7bfae] text-[#17140f] text-[11px] tracking-[0.2em] uppercase px-6 py-3 hover:border-gold hover:text-gold transition-colors whitespace-nowrap"
            >
              Nur notwendige
            </button>
            <button
              onClick={() => decide("all")}
              className="bg-gold text-[#14110c] text-[11px] tracking-[0.2em] uppercase px-6 py-3 font-medium hover:bg-[#d9b45c] transition-colors whitespace-nowrap"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
